<template>
	<div ref="el" data-component="body-media">
		<div v-if="imageAsset">
			<ImageAsset :asset="imageAsset" />
			<span v-if="imageAsset?.alt && imageAsset?.alt != ''" class="-caption-medium caption">{{ imageAsset.alt }}</span>
		</div>
	</div>
</template>

<script setup>
import { ImageAsset } from '~/components/core'

const props = defineProps({
	value: { type: Object, default: undefined },
	image: { type: Object, default: undefined },
})

const el = ref(null)

const imageAsset = computed(() => props.image || props.value?.image || null)
</script>

<style lang="scss" scoped>
[data-component='body-media'] {
	position: relative;

	padding-right: column-width(1, true);

	.caption {
		padding-top: rs(12, 12);
		padding-bottom: rs(6, 6);
		padding-left: rs(12, 12);
		height: rs(32, 32);
		color: var(--color-muted-green-300);
		border-left: solid 1px var(--color-deep-green-500);
	}

	img {
		border-radius: rs(12, 12);
		overflow: hidden;
	}
}
</style>
